var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3184 11.0561V17.0561C16.3184 17.5865 16.1076 18.0952 15.7326 18.4703C15.3575 18.8454 14.8488 19.0561 14.3184 19.0561H3.31836C2.78793 19.0561 2.27922 18.8454 1.90415 18.4703C1.52907 18.0952 1.31836 17.5865 1.31836 17.0561V6.05609C1.31836 5.52566 1.52907 5.01695 1.90415 4.64188C2.27922 4.2668 2.78793 4.05609 3.31836 4.05609H9.31836M13.3184 1.05609H19.3184M19.3184 1.05609V7.05609M19.3184 1.05609L8.31836 12.0561",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLink);
export default __webpack_public_path__ + "static/media/GreyLink.75becd6cb5508bcf58bf845fe4e913ac.svg";
export { ForwardRef as ReactComponent };